import React, { Component } from 'react';
import Service from '../service/Service';
const service = new Service();
import * as actions from './actions';
import { Helmet } from 'react-helmet';
import './Babynames.css';
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
let myData = {};
let flag = false;
var items = [];

class Finder extends Component {
    constructor(props) {
        super(props)
        let initialData = {};
        let searchData = [];
        let categoryList = [];
        this.alphabetsAry = [];
        for (let i = 0; i < 26; i++) {
            this.alphabetsAry.push((i + 10).toString(36));
        }
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            initialData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                initialData = props.staticContext.initialData['initialData'];
            }
        }
        this.state = {
            initialData: initialData,
            searchData: searchData,
            categoryList:categoryList,
            metaTitle: "Baby Names List: Find 100000+ Baby Names for Boys & Girls",
            metaDescription: [
                { "name": "description", "content": "Find the latest, most popular and unique baby names for your newborn from a list of 100000+ Baby Boy & Girl Names ideas with FirstCry’s Baby Names Finder." },
                { "name": "keywords", "content": "baby names, unique baby names, popular baby names" },
                {  "name" : "robots", "content" : "all" }
            ]
        };
    }
    componentDidMount() {
        localStorage.setItem('selectedvalgender', '');
        localStorage.setItem('selectedvalgod', '');
        localStorage.setItem('selectedvalnakshatra', '');
        localStorage.setItem('selectedvalnumerology', '');
        localStorage.setItem('selectedvalorigin', '');
        localStorage.setItem('selectedvalrashi', '');
        localStorage.setItem('selectedvalreligion', '');
        localStorage.setItem('selectedvalstarting', '');
        
        Cookies.set('selectedvalgender', []);
        Cookies.set('selectedvalgod', []);
        Cookies.set('selectedvalnakshatra', []);
        Cookies.set('selectedvalnumerology', []);
        Cookies.set('selectedvalorigin', []);
        Cookies.set('selectedvalrashi', []);
        Cookies.set('selectedvalreligion', []);
        Cookies.set('selectedvalstarting', []);
        
        //  if (typeof window === 'undefined') {
            window.scrollTo(0,0);
        // }
        // this.setState({window_width : window.innerWidth});
    }

    componentWillUnmount() {
        document.removeEventListener("click", actions.domClick);
    }


    tosearchpagedesk(){
        var item = [];
        var input, filter, ul, li, a, i, txtValue;
        input = document.getElementById("myInputdesk");
        if (input.value.trim() != '' && input.value.length > 2) {
            
            var searchkey = input.value.replace(/</g, "").replace(/>/g, "");
            var discussion_page = window.location.pathname.split('/');
            var unqformdatamain = new FormData();
            if (discussion_page[4] == "page") {
                var pageno = discussion_page[5];
            } else {
                var pageno = "1";
            }
            var urlsrt = window.location.href;
            var pageinurl = urlsrt.split("/");
            var appendUrl = pageinurl[4];

            var postArr = {
                "keyword": searchkey,
                "startWith": null,
                "gender": null,
                "origin": null,
                "religion": null,
                "numerology": null,
                "rashi":  null,
                "nakshatra": null,
                "god": null,
                "sortkey": "",
                "pageNo": pageno,
                "pageSize": 15
            }
            var url =  global.api_ci_url + "Babynames/getbabysearchbyfilters";
            service.postServiceCall(url, postArr).then((json) => {
                flag = true;
                if (json['SearchData'] != "Records Not Found" ) {
                    this.setState({ searchData: json['SearchData'] }, () => {service.loadImages(); actions.loadSliders();})
                    this.setState({ categoryList: ''})
                } else{
                    this.setState({ searchData: ''})
                    this.setState({ categoryList: json['categoryList'] }, () => {service.loadImages(); actions.loadSliders();})
                    
                }
            }).catch((error) => {
                console.error(error);
            });
        } else {
            document.querySelector(".no_record_page").style.display = "none";
            document.querySelector("#mytempul").style.display = "none";
        }
    }

    searchfound(){
        var items = [];
        var dataA = this.state.listingData;
        document.getElementById("mytempul").style.display = "block";
        document.querySelector(".no_record_page").style.display = "none";
        this.state.searchData.map((value, index) => {
        items.push(<li key={index}>
                <div className="name-info" onClick={(e) => actions.tonamedetails(e,value.recordid, value.babyname)}>
                    <a href={service.getRedirectUrl(`/baby-names/meaning-of-${value.babyname.replace(/-/g, "").replace(/ /g, "-").toLowerCase()}/`)} title={value.babyname}>
                        {this.checkGender(value.gender)}
                        <div className="names">
                            <div className="baby-name M14_42">{value.babyname}</div>
                            <span className="nm-ming R13_9e">{value.meaning}</span>
                        </div>
                    </a>
                </div>
                <span className="search-arrow icon right" data-icon-font="i" onClick={(e) => this.searchThisName(value.babyname)}></span>
            </li>
            )
        })

        return (
                items
        )
    }
    searchThisName(name) {
        document.getElementById("myInputdesk").value = name;
        this.tosearchpagedesk();
    }
    checkGender(gender){
        if(gender == "Boy") {
            return (<span className="gender-icon icon left" data-icon-font="&#xe022;"></span>)
        } else if(gender == "Girl"){ 
            return (<span className="gender-icon icon left" data-icon-font="&#xe01f;"></span>)
        }else{
            return (<span className="gender-icon icon left" data-icon-font="&#xe029;"></span>)
        }
    }
    noSearch() {
        document.getElementById("mytempul").style.display = "none";
        document.querySelector(".no_record_page").style.display = "block";
        var items = [];
        this.state.categoryList.map((value, index) => {
            var gendername = value.cat_filter[0].key;
            var religionname = value.cat_filter[1].key;
            var catName = value.category_name;


            if((gendername.length > 1)){
                var gen = gendername[0] +  ", " + gendername[1] +  ", " +gendername[2];
            } else {
                var gen = gendername;
            }

            items.push(
                <li key={index} onClick={(e) => actions.toListingPage(`${catName}`, `${gen}`, `${religionname}`,` `, this)}>
                        <span className="R14_42 category_title"> {religionname} Baby {gen} Names</span>
                        <span className="R14_9e icon right" data-icon-font="l"></span>
                </li>);
            }
        )
        return (
            items
        )
    }
    searchGivenName(target){
        var input = document.getElementById("myInputdesk");
        if(target.charCode == 13){
            if(input.value.trim() != '' ){
                window.location.href = service.getRedirectUrl("/baby-names/finder/" + document.getElementById("myInputdesk").value + "/");
            } else {
                service.showAlert("Please Enter Name to Search");
            }
        }
    }
    clearSearch(){
        document.getElementById("mytempul").style.display = 'none';
        document.getElementById("myInputdesk").value = '';
        document.querySelector('.no_record_page').style.display = "none";
        document.getElementsByTagName('body')[0].style.overflow = "unset";
    }


    render() {
      
        var myData = '';
        if(flag){
            
            if(this.state.searchData && this.state.searchData.length > 0){
                
                myData =  this.searchfound();
            } else if(this.state.categoryList.length > 0) {
                myData = this.noSearch();
            }
        }
        return (
            <main className="baby-names-main main-container">
                <div className="data-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link className="R11_9e" to={service.getRedirectUrl("/")}>Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link className="R11_9e" to={service.getRedirectUrl("/baby-names")}>Baby Names</Link></span>
                    </div>
                    <h1 className="B24_00"> Baby Names Finder</h1>
                </div>
                <div className="sub-container">
                    <div className="search_result_container">
                        <div className="finder_block">
                            <div className="search_container" style={{overflow: 'visible'}}>
                                <div className="search_header">
                                    <span className="desksearch_input">
                                        <Link to={service.getRedirectUrl(`/baby-names`)} className="backToLanding">
                                            <span className="icon backarrow left" data-icon-font="s"></span>
                                        </Link>
                                        <div className="search_here">
                                            <span className="icon search_icon" data-icon-font="'"></span>
                                            <input type="text" name="" id="myInputdesk" onKeyUp={() => this.tosearchpagedesk()} onKeyPress={this.searchGivenName} placeholder="Search" autoFocus />
                                        </div>
                                        <span className="icon closeicon right" data-icon-font="C" onClick={() => this.clearSearch()}></span>
                                    </span>
                                </div>
                            </div>
                            <ul id="mytempul">
                                {myData}
                            </ul>
                        </div>
                        <div className="no_record_page">
                            <div className="R15_9e term_not_found"></div>
                            <div className="R15_9e try_another_name">Try searching for other term</div>
                            <div className="M14_42 browse_names">Browse our popular Categories</div>
                            <ul>
                                {myData}
                            </ul>
                        </div>
                    </div>
                </div>
                </div>
            </main>
        )
    }
}

export default Finder



// WEBPACK FOOTER //
// src/shared/baby-names/Finder.js